import React from 'react';
import {useForm} from 'react-hook-form';

function GatewayClinicInfoForm({clinicInfo, updateInfo}) {
    const {register, handleSubmit, formState: {errors}} = useForm({
        defaultValues: clinicInfo
    });

    const onSubmit = (data) => {
        updateInfo(data);
    };

    return (
        <div className="card shadow-none">
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row g-3">
                        {/* Name */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="name" className="form-label">
                                <i className="bi bi-building me-1"></i> Clinic Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                {...register("name", {required: "Clinic name is required"})}
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                        </div>

                        {/* Email */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="email" className="form-label">
                                <i className="bi bi-envelope me-1"></i> Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                {...register("email", {
                                    required: "Email is required",
                                    pattern: {
                                        value: /^\S+@\S+$/i,
                                        message: "Invalid email format"
                                    }
                                })}
                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                        </div>

                        {/* Phone */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="phone" className="form-label">
                                <i className="bi bi-telephone me-1"></i> Phone
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                {...register("phone", {required: "Phone number is required"})}
                                className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                            />
                            {errors.phone && <div className="invalid-feedback">{errors.phone.message}</div>}
                        </div>

                        {/* SMS (Disabled) */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="sms" className="form-label">
                                <i className="bi bi-chat-left-text me-1"></i> SMS Number
                            </label>
                            <input
                                type="text"
                                id="sms"
                                {...register("sms")}
                                disabled
                                className="form-control bg-light"
                            />
                        </div>

                        {/* Signature */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="signature" className="form-label">
                                <i className="bi bi-pen me-1"></i> Signature
                            </label>
                            <input
                                type="text"
                                id="signature"
                                {...register("signature")}
                                className="form-control"
                            />
                        </div>

                        {/* Website */}
                        <div className="col-md-6 p-2">
                            <label htmlFor="website" className="form-label">
                                <i className="bi bi-globe me-1"></i> Website
                            </label>
                            <input
                                type="url"
                                id="website"
                                {...register("website")}
                                className="form-control"
                                placeholder="https://"
                            />
                        </div>

                        {/* Address Section */}
                        <div className="col-12 mt-4">
                            <h5 className="mb-3">
                                <i className="bi bi-geo-alt me-2"></i> Address Information
                            </h5>
                        </div>

                        {/* Street */}
                        <div className="col-md-8">
                            <label htmlFor="street" className="form-label">
                                Street Address
                            </label>
                            <input
                                type="text"
                                id="street"
                                {...register("street", {required: "Street address is required"})}
                                className={`form-control ${errors.street ? 'is-invalid' : ''}`}
                            />
                            {errors.street && <div className="invalid-feedback">{errors.street.message}</div>}
                        </div>

                        {/* City */}
                        <div className="col-md-4">
                            <label htmlFor="city" className="form-label">
                                City
                            </label>
                            <input
                                type="text"
                                id="city"
                                {...register("city", {required: "City is required"})}
                                className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                            />
                            {errors.city && <div className="invalid-feedback">{errors.city.message}</div>}
                        </div>

                        {/* Postal Code */}
                        <div className="col-md-4">
                            <label htmlFor="postalCode" className="form-label">
                                Postal Code
                            </label>
                            <input
                                type="text"
                                id="postalCode"
                                {...register("postalCode", {required: "Postal code is required"})}
                                className={`form-control ${errors.postalCode ? 'is-invalid' : ''}`}
                            />
                            {errors.postalCode && <div className="invalid-feedback">{errors.postalCode.message}</div>}
                        </div>

                        {/* Province */}
                        <div className="col-md-4">
                            <label htmlFor="province" className="form-label">
                                Province/State
                            </label>
                            <input
                                type="text"
                                id="province"
                                {...register("province", {required: "Province is required"})}
                                className={`form-control ${errors.province ? 'is-invalid' : ''}`}
                            />
                            {errors.province && <div className="invalid-feedback">{errors.province.message}</div>}
                        </div>

                        {/* Country */}
                        <div className="col-md-4">
                            <label htmlFor="country" className="form-label">
                                Country
                            </label>
                            <input
                                type="text"
                                id="country"
                                {...register("country", {required: "Country is required"})}
                                className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                            />
                            {errors.country && <div className="invalid-feedback">{errors.country.message}</div>}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button type="submit" className="btn btn-success px-4">
                            <i className="bi bi-save me-2"></i> Save Changes
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default GatewayClinicInfoForm;